import { render, staticRenderFns } from "./SendMessageOtherUserGroupSelectModal.vue?vue&type=template&id=7f6a88d6&lang=pug"
import script from "./SendMessageOtherUserGroupSelectModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageOtherUserGroupSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageOtherUserGroupSelectModal.vue?vue&type=style&index=0&id=7f6a88d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports